/**
 * Route adapter for /production-records/:productionNumber.
 * Pulls the production number from the URL and hands it to the detail page wrapper,
 * inside the standard Layout chrome so navigation/sidebar stay in place.
 */
import { useParams, useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import { ProductionRecordDetailPage } from './components/ProductionRecordDetailView';

const ProductionRecordDetailRoute = () => {
  const { productionNumber } = useParams<{ productionNumber: string }>();
  const navigate = useNavigate();

  if (!productionNumber) {
    return (
      <Layout>
        <div className="p-8 text-center text-gray-500 dark:text-gray-400">
          Missing production number
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <ProductionRecordDetailPage
        productionNumber={productionNumber}
        onBack={() => navigate(-1)}
      />
    </Layout>
  );
};

export default ProductionRecordDetailRoute;
